const type = "Button";

const menuItems = [
    {
        label: "Início",
        type: type,
        to: "inicio",
    },
    {
        label: "Informações",
        type: type,
        to: "rip",

    },
    {
        label: "Contato",
        type: type,
        to: "contato",
    },
    {
        label: "Newsletter",
        type: type,
        to: "newsletter",
    }
];

export default menuItems;
